import './pop-up.scss'
import React, { useState, useEffect, useRef } from 'react'
import { toastr } from 'react-redux-toastr'
import { useHistory } from 'react-router'
import { IonInput, IonItem, IonList } from '@ionic/react'
import ReCAPTCHA from 'react-google-recaptcha'
import closeDetailed from './SignUpTab/images/closeDetailed.svg'
import eyeOff from '../../assets/images/eyeOff.svg'
import closePromo from '../../assets/images/closeCross3.svg'
import { connectLoginPopUp } from './loginPopUp.connect'
import UpdatePopUp from '../../components/UpdatePopUp/index.js'
import LogInStep from './LogInStep/LogInStep'
import SignUpTab from './SignUpTab/SignUpTab'
import ForgotPasswordTab from './ForgotPassword/ForgotPasswordTab'
import promoDefault from '../../assets/images/promoDefault.png'
import RulesRegs from '../../pages/RulesRegs/RulesRegs'
import { createPortal } from "react-dom";
import { showDeposit } from "../../helpers/showDeposit.helper";

const modalRoot = document.querySelector("#modal-root");

const LoginPopUp = ({
  open,
  onDidDismiss,
  auth,
  recaptcha,
  actions,
  version,
  B2C,
  scrollPosition,
  isDetailedPromo,
  promoInfo,
  isTermCondition,
  // tab = 1
  tab = 1,
  elementsParams
}) => {
  const refRecaptcha = useRef(null)
  const history = useHistory()
  let [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (!auth) {
      actions.requestRecaptcha()
    }
  }, [auth])

  useEffect(() => {
    if (!onDidDismiss) {

      //  setTabButton(1)
      actions.setTab(1)
    }
  }, [onDidDismiss])

  // useEffect(() => {
  //   setTabButton(tab)
  // }, [tab]);
  
  //window width
  const width = elementsParams && elementsParams?.clientWidth ? elementsParams?.clientWidth : window.innerWidth
  //end window width

  const windowLoc = () => {
      history.push('/default-page')
      window.location.href = window.location.pathname.replace('/register', '/')
      // setLocation('')
  }

  // console.log('window', window?.location?.href);

  useEffect( () => {

    if (B2C) {
      // .then((res) => setPromoList(res.data.result))
      // console.log(object);
    }
  }, []);

  const getBalance = (memberCode) => {
    actions
      .requestBalance(memberCode)
      .then((res) => {
        if (res.data.result.availBalance < 100) {
          history.push('/deposit')
        }
      })
      .catch((e) => console.log('balance error = ', e))
  }

  const submit = async () => {
    try {
      if (!username || !password || loading) return
      setLoading(true)
      const recaptchaResponse = await refRecaptcha.current.executeAsync()
      let newUserName = ''
      if (B2C) {
        newUserName = `91_${username}`
        await actions
          .requestAuth({
            username: newUserName,
            password,
            recaptchaResponse,
            answer: '',
            token: '',
          })
          .then((res) => {
            setLoading(false)
            if(B2C && showDeposit()){
              getBalance(res.data.result.memberCode)
            }
            onDidDismiss()
          })
      } else {
        await actions
          .requestAuth({
            username,
            password,
            recaptchaResponse,
            answer: '',
            token: '',
          })
          .then((res) => {
            setLoading(false)
          })
      }
    } catch (e) {
      setLoading(false)
      toastr.error('', `${e}`)
      if (refRecaptcha.current) refRecaptcha.current.reset()
    }
  }

  const onKeyDown = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault()
      event.stopPropagation()
      submit()
    }
  }

  const changeName = (e) => {
    setUsername(e.detail.value)
  }

  const changePass = (e) => {
    setPassword(e.detail.value)
  }

  function createMarkup(info) {
    return { __html: info.replaceAll('\\n', '') }
  }

  // update pop-up
  // const [isOpen, setIsOpen] = useState(false)

  // useEffect(() => {
  //   let versionNow = version

  //   console.log(version)

  //   if (version) {
  //     if (localStorage.getItem('versionNow') === versionNow) {
  //       return console.log('version up to date')
  //     } else if (!localStorage.getItem('versionNow')) {
  //       localStorage.setItem('versionNow', versionNow)
  //     } else if (localStorage.getItem('versionNow') != versionNow) {
  //       setIsOpen((isOpen) => !isOpen)
  //       localStorage.setItem('versionNow', versionNow)
  //     }
  //   }
  // }, [version])

  const [focus, setFocus] = useState(false)

  // const animationClass = () => {
  //   if (width >= 1024 && !onDidDismiss){
  //     return 'popUpAnimation'
  //   } else if (width >= 1024 && onDidDismiss){
  //     return 'popUpCloseAnimation'
  //   } else {
  //     return 
  //   }
  // } 

  // const showHide = () => {
  //   setShow(!show)
  // }
  // const [show, setShow] = useState(false)


  return createPortal(
    <>
      {open && (
        <div className="loginPopUp">
          <div
            // style={{ top: scrollPosition + 'px' }}
            className={`pop-up_wrapper ${width < 1024 && tab === 2 && 'popUpAnimation'}`}
            // onClick={(e) => {
            //   if (e.currentTarget === e.target) {
            //     onDidDismiss(false)
            //   }
            // }}
            // TODO: variable to be used for svg
          >
            <div className={`pop-up ${width <= 1024 && tab === 1 && "login-desktop"}`}>
              <div className="closePopUpButton" onClick={() => {
                onDidDismiss(false)
                windowLoc()
              }}>
                <svg
                  width="31"
                  height="31"
                  viewBox="0 0 31 31"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle cx="15.5" cy="15.5" r="15.5" fill="#142326" />
                  <path
                    d="M11.2045 10.0005C10.9659 10.0008 10.7328 10.0722 10.5349 10.2057C10.3371 10.3391 10.1835 10.5285 10.0938 10.7496C10.0042 10.9707 9.98244 11.2136 10.0314 11.4471C10.0804 11.6806 10.1979 11.8943 10.3689 12.0607L13.7205 15.4122L10.3689 18.7638C10.2538 18.8744 10.1618 19.0068 10.0985 19.1534C10.0351 19.2999 10.0017 19.4576 10.0001 19.6173C9.99844 19.7769 10.0287 19.9353 10.089 20.0831C10.1494 20.2309 10.2386 20.3652 10.3515 20.4781C10.4644 20.591 10.5987 20.6802 10.7465 20.7406C10.8943 20.8009 11.0527 20.8312 11.2123 20.8296C11.372 20.8279 11.5297 20.7945 11.6763 20.7311C11.8228 20.6678 11.9552 20.5758 12.0658 20.4607L15.4174 17.1091L18.7689 20.4607C18.8795 20.5758 19.012 20.6678 19.1585 20.7311C19.3051 20.7945 19.4628 20.8279 19.6224 20.8296C19.7821 20.8312 19.9405 20.801 20.0883 20.7406C20.2361 20.6803 20.3704 20.591 20.4833 20.4781C20.5962 20.3652 20.6854 20.2309 20.7457 20.0831C20.8061 19.9353 20.8363 19.7769 20.8347 19.6173C20.8331 19.4577 20.7996 19.2999 20.7363 19.1534C20.6729 19.0068 20.581 18.8744 20.4658 18.7638L17.1143 15.4122L20.4658 12.0607C20.6392 11.8921 20.7577 11.6751 20.8056 11.4381C20.8536 11.2011 20.8288 10.9551 20.7345 10.7324C20.6403 10.5097 20.481 10.3206 20.2774 10.19C20.0739 10.0595 19.8357 9.99339 19.5939 10.0005C19.2822 10.0098 18.9863 10.1401 18.7689 10.3638L15.4174 13.7154L12.0658 10.3638C11.9539 10.2487 11.8199 10.1573 11.672 10.0949C11.524 10.0325 11.3651 10.0004 11.2045 10.0005V10.0005Z"
                    fill="#fff"
                  />
                </svg>
              </div>
              <div className="pop-up-content">
                {width > 1024 && B2C &&
                  <div className="tabButtons">
                    <div
                      className={`tabButtons__button ${
                        tab === 2 ? '' : 'inActiveLeft'
                      }`}
                      onClick={() => actions.setTab(2)}
                    >
                      Sign up
                    </div>
                    <div
                      className={`tabButtons__button ${
                        tab === 1 || tab === 3 ? '' : 'inActiveRight'
                      }`}
                      onClick={() =>  actions.setTab(1)}
                    >
                      Log in
                    </div>
                  </div>
                }
              </div>
                    {tab === 1 && width > 1024 && <div className="logo"></div>}
              {tab === 1 && (
                <LogInStep
                  recaptchaResponseProps={refRecaptcha}
                  onDidDismiss={onDidDismiss}
                  width={width}
                  setFocus={setFocus}
                  focus={focus}
                />
              )}
              {tab === 2 && (
                <SignUpTab
                  recaptchaResponse={refRecaptcha}
                  onDidDismiss={onDidDismiss}
                  width={width} />
              )}
              {tab === 3 && (
                <ForgotPasswordTab
                  recaptchaResponse={refRecaptcha}
                  onDidDismiss={onDidDismiss}
                  width={width} />
              )}

              {isDetailedPromo && (
                <div
                  className="detailedPromotions"
                  onClick={() => actions.setIsDetailedPromo(false)}
                >
                  <div
                    className="pop-up-content_title"
                  >
                    <img className='detailedPromoClose' src={width > 1024 ? closeDetailed : closePromo} onClick={() => actions.setIsDetailedPromo(false)}/>

                  </div>
                  <div className="detailedPromotions-promo-image">
                    <img
                      src={(promoInfo?.promoImageUrl) || promoDefault}
                    />
                  </div>
                  <div dangerouslySetInnerHTML={createMarkup(promoInfo?.info)} />
                </div>
              )}
              {isTermCondition && (
                <div
                  className="detailedPromotions"
                  onClick={() => actions.setIsTermCondition(false)}
                >
                  <div
                    className="pop-up-content_title"
                  >
                    <img className='detailedPromoClose' src={closeDetailed} onClick={() => actions.setIsTermCondition(false)}/>

                  </div>
                  <RulesRegs isPopUp={true} />
                </div>
              )}
            </div>
          </div>
          {recaptcha ? (
            <ReCAPTCHA
              ref={refRecaptcha}
              sitekey={recaptcha}
              badge="bottomright"
              size="invisible"
            />
          ) : null}
          {/* <UpdatePopUp isOpen={isOpen} /> */}
        </div>
      )}
    </>, modalRoot
  )
}

export default connectLoginPopUp()(LoginPopUp)
